// @mui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { HOST_ENV } from 'src/config-global';
import packageJson from '../../../package.json';
// ----------------------------------------------------------------------

export default function NavUpgrade() {
  return (
    <Stack 
      direction="column"
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
      spacing={2}
    >
      <Typography 
        variant="caption" 
        sx={{
          fontSize: 12
        }}
      >
        All Rights Reserved. &copy; {new Date().getFullYear()} {packageJson.name}
      </Typography>

      <Typography 
        variant="caption"
        sx={{
          fontSize: 12
        }}
      >
        {HOST_ENV} v{packageJson.version}
      </Typography>
    </Stack>
  );
}
